import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  if (active) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-testid="blog-detail">
        <button onClick={() => setActive(null)} className="text-ub-2 hover:text-primary-ub mb-6">← Back to Wisdom</button>
        <div className="text-xs uppercase tracking-widest text-primary-ub">{active.tag} · {active.date}</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 leading-[1.02] tracking-tighter">{active.title}</h1>
        <img src={active.cover} alt="" className="mt-8 w-full h-80 object-cover rounded-3xl" />
        <p className="mt-8 text-lg text-ub-2 leading-relaxed">{active.excerpt}</p>
        <p className="mt-6 text-lg text-ub-2 leading-relaxed">{active.content}</p>
        <p className="mt-8 font-script text-2xl text-primary-ub">— {active.author}</p>
      </div>
    );
  }

  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="text-sm uppercase tracking-[0.25em] text-primary-ub">Wisdom</div>
      <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-4 leading-[1.02] tracking-tighter">
        Slow reads for<br/> a <span className="italic text-primary-ub">full</span> life.
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        {posts.map((p) => (
          <button
            key={p.id}
            onClick={() => setActive(p)}
            data-testid={`blog-open-${p.id}`}
            className="group text-left"
          >
            <div className="overflow-hidden rounded-3xl">
              <img src={p.cover} alt={p.title} className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="mt-5">
              <div className="text-xs uppercase tracking-widest text-muted-ub">{p.tag} · {p.date}</div>
              <h3 className="font-serif text-2xl mt-2 leading-snug group-hover:text-primary-ub transition-colors">{p.title}</h3>
              <p className="text-ub-2 mt-2">{p.excerpt}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
